var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-settings-popup",
    {
      attrs: {
        resources: {
          deletePromptTitle: _vm.resource(
            "JourneyBuilder_BrickSettingsAudienceFilter_Delete_Title"
          ),
          deletePromptBody: _vm.resource(
            "JourneyBuilder_BrickSettingsAudienceFilter_Delete_Body"
          ),
          brickTitle:
            _vm.resource("JourneyComposer_BrickSettingsAudienceFilter_Title") +
            " " +
            _vm.resource("JourneyComposer_BrickSettingsBase_Title")
        },
        brick: _vm.brick,
        name: _vm.newName
      },
      on: {
        "update:name": function($event) {
          _vm.newName = $event
        },
        save: function($event) {
          return _vm.saveSettings()
        },
        delete: function($event) {
          return _vm.$emit("delete")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("span", { staticClass: "conditions-header" }, [
        _vm._v(
          _vm._s(
            _vm.resource(
              "JourneyComposer_BrickSettingsAudienceFilter_Conditions_DisplayName"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("id-dispenser", {
        attrs: { elements: _vm.settings.conditions },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var idsPerElement = ref.idsPerElement
              return [
                _vm._l(_vm.settings.conditions, function(condition, index) {
                  return [
                    _c("div", { key: idsPerElement.get(condition) }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("audience-filter-brick-condition", {
                              staticClass: "filter-condition",
                              attrs: {
                                name: condition.name,
                                color: condition.color,
                                fields: condition.fields
                              },
                              on: {
                                "update:name": function($event) {
                                  return _vm.$set(condition, "name", $event)
                                },
                                "update:color": function($event) {
                                  return _vm.$set(condition, "color", $event)
                                },
                                "update:fields": function($event) {
                                  return _vm.$set(condition, "fields", $event)
                                },
                                delete: function($event) {
                                  return _vm.deleteConditionAt(index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-8" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-4" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary btn-icon-left w-100",
              attrs: { disabled: !_vm.canWrite },
              on: { click: _vm.addNewCondition }
            },
            [
              _c("i", { staticClass: "fa fa-plus" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.resource(
                      "JourneyComposer_BrickSettingsAudienceFilter_AddCondition_DisplayName"
                    )
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }